<ng-container *ngIf="text; else contentTpl">
    {{ text }}
</ng-container>
<ng-template #contentTpl>
    <ng-container *ngTemplateOutlet="contentTemplate; context: getContext()"></ng-container>
</ng-template>
